var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-loading',{attrs:{"active":_vm.$auth.loading}}),(!_vm.$auth.loading)?_c('AppLayout',[_c('keep-alive',[_c('router-view')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }